import { render, staticRenderFns } from "./Pocetna.vue?vue&type=template&id=4ebebac5&scoped=true&"
import script from "./Pocetna.vue?vue&type=script&lang=js&"
export * from "./Pocetna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebebac5",
  null
  
)

export default component.exports